<script setup lang="ts" name="ErrorLayout">
import G2OBrandPattern from '~/components/G2OBrandPattern.vue';
import LogoMYG2O from '~/components/LogoMYG2O.vue';
</script>

<template>
  <div class="flex h-screen flex-col bg-white">
    <div
      class="m-4 flex justify-between sm:m-8 lg:mx-auto lg:w-08/12 xl:w-8/12"
    >
      <div class="flex-shrink-0">
        <RouterLink to="/" class="flex-shrink-0">
          <LogoMYG2O />
        </RouterLink>
      </div>

      <G2OBrandPattern />
    </div>

    <div class="mt-32">
      <slot />
    </div>
  </div>
</template>
